"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Colors = void 0;
exports.Colors = {
    Red: {
        keyword: 'red',
        rgba: [255, 0, 0, 1],
    },
    White: {
        keyword: 'white',
        rgba: [255, 255, 255, 1],
    },
    Black: {
        keyword: 'black',
        rgba: [0, 0, 0, 1],
    },
    Transparent: {
        keyword: 'transparent',
        rgba: [0, 0, 0, 0],
    },
};
//# sourceMappingURL=colors.js.map